import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

/**
 * A text field that shows the whole answer (PLAN_venueswest A): it grows to fit what is in it, so a long answer is
 * read and edited in full rather than scrolled sideways in a single line. No mode to switch into.
 */
export function AutoTextarea({ value, minRows = 1, className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement> & { value: string; minRows?: number }) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;   // + the border, so the last line is never clipped
  }, [value]);
  return <textarea ref={ref} rows={minRows} value={value} className={`auto-textarea${className ? ` ${className}` : ""}`} {...rest} />;   // a caller's class adds to ours, never replaces it
}
